import { fromNode, ViewModel } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

export class TransformerModel extends ViewModel {
  /*
   * 依赖收集执行器
   */
  @fromNode()
  @reactive()
  tracker?: Function

  @reactive('computed')
  get value() {
    return this.tracker?.()
  }
}
